export default "__VITE_ASSET__5dVFw0H2__"